import React, { useRef } from 'react';
import { useTranslation } from 'react-i18next';

import './careFuture.scss';
import { BlueWave, LightEllipse } from 'src/assets';
import { useAnimatedView } from 'src/hooks/useAnimatedView';

export const CareFuture = () => {
  const { t } = useTranslation();

  const ref = useRef();
  const { isVisible } = useAnimatedView(ref);

  return (
    <div className="care-future">
      <div className={`care-future-content ${isVisible ? 'active-animation' : ''}`} ref={ref}>
        <div className="care-future-title">
          <supertitle className="care-future-supertitle">{t('careFuture:supertitle')}</supertitle>
          <h1 className="care-future-title-heading">
            <blue-text>{t('careFuture:care')}</blue-text>{' '}
            <blue-underline>{t('careFuture:future')}</blue-underline>
            <br /> {t('careFuture:withUs')}
          </h1>
        </div>

        <div className="care-future-section">
          <img src={BlueWave} alt={BlueWave} className="care-future-section-wave" />

          <div className="care-future-section-item">
            <div className="care-future-section-item-number">01.</div>
            <h3 className="care-future-section-item-title">{t('careFuture:registration')}</h3>
            <div className="care-future-section-item-subtitle">
              {t('careFuture:registrationSub')}
            </div>
          </div>
          <div className="care-future-section-item">
            <div className="care-future-section-item-number">02.</div>
            <h3 className="care-future-section-item-title">{t('careFuture:refill')}</h3>
            <div className="care-future-section-item-subtitle">{t('careFuture:refillSub')}</div>
          </div>
          <div className="care-future-section-item">
            <div className="care-future-section-item-number">03.</div>
            <h3 className="care-future-section-item-title">{t('careFuture:trade')}</h3>
            <div className="care-future-section-item-subtitle">{t('careFuture:tradeSub')}</div>
          </div>
        </div>

        <img src={LightEllipse} alt={LightEllipse} className="care-future-image-1" />
      </div>
    </div>
  );
};
